import React, { forwardRef, useEffect, useRef, useState } from 'react';
import styles from './TableListEditableNew.module.scss';

interface TextAreaCellEditorProps {
  value?: string | number | null;
  maxLength?: number;
  onValueChange?: (value: string) => void;
}

const TextAreaCellEditor = forwardRef<any, TextAreaCellEditorProps>((props, _ref) => {
  const [value, setValue] = useState(String(props.value ?? ''));
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
    textareaRef.current?.select();
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const nextValue = event.target.value;
    if (props.maxLength && nextValue.length > props.maxLength) return;
    setValue(nextValue);
    props.onValueChange?.(nextValue);
  };

  return (
    <textarea
      ref={textareaRef}
      className={styles.TextAreaEditor}
      value={value}
      onChange={handleChange}
      rows={2}
    />
  );
});

TextAreaCellEditor.displayName = 'TextAreaCellEditor';

export default TextAreaCellEditor;
